import { Popover } from './modules/popover.js';
import { WebModal } from './modules/modal.js';
import { CustomModule } from './custom.js';

/* global web, moment */
export class App {
  constructor (settings, onBindAll) {
    this.settings = settings || null;
    this.blocked = false;

    this.onBindAll = onBindAll || false;

    if (Popover) {
      this.popover = new Popover(this, this.settings);
    }

    if (WebModal) {
      this.modal = new WebModal(this, this.settings.modal);
    }

    if (CustomModule) {
      this.custom = new CustomModule(this);
    }
  }

  resetForm (selector) {
    $(selector).find('input:text, input:password, input:file, select, textarea').val('');
    $(selector).find('input:radio, input:checkbox').removeAttr('checked').removeAttr('selected');
  }

  iniDatePicker (selector) {
    let self = this;
    $(selector).on('click', function () {
      let that = this;

      if ($(this).data('inline')) {
        $(that).parent().append("<i class='datepicker icon icon-calendar'></i>");
      }

      var options = {
        format: $(this).data('format') || 'Y-m-d',
        lang: $(this).data('lang') || 'es',
        timepicker: $(this).data('timepicker') || false,
        weeks: $(this).data('weeks') || false,
        inline: $(this).data('inline') || false,
        defaultDate: $(this).data('default') || false,
        defaultTime: $(this).data('default-time') || false,
        dayOfWeekStart: 1,
        closeOnDateSelect: true,
        onGenerate: function (ct, $i) {
          if ($(that).data('ongenerate')) { self._runFuncByName($(that).data('ongenerate'), window, {'date': ct.dateFormat(options.format), 'selector': $(this)}); }
        },
        onSelectDate: function (ct) {
          if ($(that).data('onselect')) { self._runFuncByName($(that).data('onselect'), window, {'date': ct.dateFormat(options.format)}); }
        },
        onChangeMonth: function (ct) {
          if ($(that).data('onchangemonth')) { self._runFuncByName($(that).data('onchangemonth'), window, {'date': ct.dateFormat(options.format)}); }
        },
        onChangeYear: function (ct) {
          if ($(that).data('onchangeyear')) { self._runFuncByName($(that).data('onchangeyear'), window, {'date': ct.dateFormat(options.format)}); }
        },
        beforeShowDay: function (ct) {
          if ($(that).data('beforeshow')) { return self._runFuncByName($(that).data('beforeshow'), window, {'date': ct.dateFormat(options.format)}); }
        },
        onClose: function (ct, $i) {
          /* if ($('[aria-describedby]').length) {
            $('[aria-describedby]').popover('destroy');
            $('body').unbind('click.popover');
          } */
          $i.datetimepicker('destroy');
        }
      };

      $(this).datetimepicker(options).datetimepicker('show');
    });
  }

  iniTimePicker (selector) {
    $(selector).on('click', function () {
      var that = this;

      if ($(this).data('inline')) { $(that).parent().append("<i class='datepicker icon icon-calendar'></i>"); }

      var options = {
        format: $(this).data('format') || 'H:i',
        lang: $(this).data('lang') || 'es',
        datepicker: false,
        timepicker: true,
        weeks: $(this).data('weeks') || false,
        inline: $(this).data('inline') || false,
        step: 15,
        timepickerScrollbar: true,
        onClose: function (ct, $i) {
          /* if ($('[aria-describedby]').length) {
            $('[aria-describedby]').popover('destroy');
            $('body').unbind('click.popover');
          } */
          $i.datetimepicker('destroy');
        }
      };

      $(this).datetimepicker(options);
      $(this).datetimepicker('show');
    });
  }

  iniMonthPicker (selector) {
    $(selector).on('click', function () {
      var that = this;
      var options = {
        format: $(this).data('format') || 'Y-m',
        lang: $(this).data('lang') || 'es',
        inline: $(this).data('inline') || false,
        defaultDate: $(this).data('default') || false,
        timepicker: false,
        dayOfWeekStart: 1,
        onGenerate: function (ct) {
          $(that).val(ct.dateFormat(options.format));
          $(this).find('.xdsoft_calendar').hide();
        },
        onChangeMonth: function (ct) {
          $(that).val(ct.dateFormat(options.format));
        },
        onChangeYear: function (ct) {
          $(that).val(ct.dateFormat(options.format));
        },
        onClose: function (ct, $i) {
          /* if ($('[aria-describedby]').length) {
            $('[aria-describedby]').popover('destroy');
            $('body').unbind('click.popover');
          } */
          $i.datetimepicker('destroy');
        }
      };

      $(this).datetimepicker(options);
      $(this).datetimepicker('show');
    });
  }

  inlineMonthPicker (selector) {
    $(selector).each(function () {
      let date;
      let that = this;
      let options = {
        format: $(this).data('format') || 'Y-M',
        lang: $(this).data('lang') || 'es',
        inline: $(this).data('inline') || false,
        defaultDate: $(this).data('default') || false,
        timepicker: false,
        dayOfWeekStart: 1,
        onGenerate: function (ct) {
          date = moment(ct);
          $(that).val(date.format(options.format)).change();
          $(this).find('.xdsoft_calendar').hide();
        },
        onChangeMonth: function (ct) {
          date = moment(ct);
          $(that).val(date.format(options.format)).change();
        },
        onChangeYear: function (ct) {
          date = moment(ct);
          $(that).val(date.format(options.format)).change();
        }
      };

      $(this).datetimepicker(options);
    });
  }

  ajaxReplace (url, target, params = false, loader = false, complete = false) {
    this.ajaxLink(url, target, params, loader, complete, false, {
      type: 'replace'
    });
  }

  ajaxLink (url, target, params, loader, complete, object, data, ...extra) {
    var regexp = new RegExp("'", 'g');
    var settings = {
      url: url.replace(regexp, '') || false,
      target: target ? target.replace(regexp, '') : false,
      params: params || false,
      complete: complete || false,
      loader: loader || false,
      data: data || {}
    };

    if (this.blocked) return;

    this.blocked = true;

    if (settings.loader !== false) {
      $(object).addClass(this.settings.loader.class);
    }

    $.ajax({
      url: settings.url,
      context: document.body,
      data: settings.params,
      success: (data, textStatus) => {
        if ($('#' + settings.target)) {
          if (data.search('<append>') !== -1) {
            $('#' + settings.target).append(data);
            if ($(data).attr('id')) {
              this.bindAll('#' + $(data).attr('id'));
            } else {
              this.bindAll($('#' + settings.target));
            }
          } else if (settings.data.type === 'replace') {
            $('#' + settings.target).replaceWith(data);
            if ($(data).attr('id')) {
              this.bindAll('#' + $(data).attr('id'));
            } else {
              this.bindAll();
            }
          } else {
            $('#' + settings.target).html(data);
            this.bindAll($('#' + settings.target));
          }
        }

        if (settings.complete !== false) {
          this.blocked = false;
          if ($.type(settings.complete) === 'function') {
            settings.complete(data);
          } else {
            this._runFuncByName(settings.complete, window, data);
          }
        }

        this.blocked = false;
        $(object).removeClass(this.settings.loader.class);
      },
      error: (xhr, ajaxOptions, thrownError) => {
        this.blocked = false;
        $(object).removeClass(this.settings.loader.class);
      }
    });
  }

  jsonLink (url, target, params, loader, complete, object) {
    if (!url) {
      // console.error('Missing href attribute');
      return false;
    }

    var regexp = new RegExp("'", 'g');
    var settings = {
      url: url.replace(regexp, '') || false,
      target: target ? target.replace(regexp, '') : false,
      params: params || false,
      complete: complete || false,
      loader: loader || false,
      method: $(object).attr('method') || 'GET'
    };

    if (this.blocked) return;

    if ($(object).attr('before-submit')) {
      web._runFuncByName($(object).attr('before-submit'), window);
    }

    this.blocked = true;

    if (settings.loader !== false) {
      $(object).addClass(this.settings.loader.class);
    }

    $.ajax({
      url: settings.url,
      context: document.body,
      data: settings.params,
      dataType: 'json',
      success: (data, textStatus) => {
        if (settings.loader !== false) {
          $(object).removeClass(this.settings.loader.class);
        }

        if (settings.complete) {
          this.blocked = false;
          if ($.type(settings.complete) === 'function') {
            settings.complete(data);
          } else {
            this._runFuncByName(settings.complete, window, data);
          }
        }

        this.blocked = false;
        $(object).find(this.settings.loader.selector).remove();
      },
      error: (xhr, ajaxOptions, thrownError) => {
        this.blocked = false;
        $(object).find(this.settings.loader.selector).remove();
      }
    });
  }

  ajaxForm (form, target, params, loader, data) {
    var regexp = new RegExp("'", 'g');
    var formObj = $('#' + form);

    params = params || '';
    loader = loader || false;
    target = target ? target.replace(regexp, '') : false;
    data = data || {};

    if (this.blocked) {
      return false;
    }

    this.blocked = true;

    if (loader) {
      var submitButton = formObj.find('[type=submit]');
      submitButton.addClass(web.settings.loader.class);
    }

    $.ajax({
      url: formObj.attr('action'),
      type: formObj.attr('method'),
      data: formObj.serialize() + params,
      success: (data, textStatus) => {
        if ($('#' + target)) {
          if (data.type === 'replace') {
            $('#' + target).replaceWith(data);
          } else {
            $('#' + target).html(data);
          }

          if (loader) {
            formObj.find(this.settings.loader.selector).removeClass(this.settings.loader.class);
          }

          this.bindAll($('#' + target));
        }

        this.blocked = false;
      },
      error: (xhr, ajaxOptions, thrownError) => {
        if (loader) {
          formObj.find(this.settings.loader.selector).removeClass(this.setting.loader.class);
        }
        this.blocked = false;
      }
    });
  }

  feedbackMsg (type, message, target) {
    var obj = target || $('.' + this.settings.feedback['class']);
    switch (type) {
      case 'error': obj.addClass(this.settings.feedback.error_class); break;
      case 'warning': obj.addClass(this.settings.feedback.warning_class); break;
      case 'progress': obj.addClass(this.settings.feedback.inprogress_class); break;
      case 'correct': obj.addClass(this.settings.feedback.correct_class); break;
    }
    obj.html(message).show();
  }

  inputToSelect (selector, sep = ',') {
    let self = this;

    $(selector).each(function () {
      if ($(this).attr('value')) {
        var input = $(this);
        var select = $('<select></select>');

        input.replaceWith(select);
        input.removeAttr('role');

        $.each(this.attributes, function (i, attrib) {
          var name = attrib.name;
          var value = attrib.value;

          if (name === 'value') {
            var values = value.split(sep);
            $.each(values, function (i, val) {
              var opt = val.split('#');
              select.append("<option value='" + opt[0] + "'>" + opt[1] + '</option>');
            });
          } else {
            select.attr(name, value);
          }
        });

        if (input.attr('on-create')) {
          self._runFuncByName(input.attr('on-create'), window, select);
        }

        if (input.attr('on-change')) {
          select.unbind('change');
          select.on('change', function () {
            self._runFuncByName(input.attr('on-change'), window, select);
          });
        }

        if (input.attr('default') !== undefined) {
          select.val(input.attr('default')).change();
        } else {
          select.val(select.children('option:first').val()).change();
        }
      }
    });
  }

  bindAjaxClick (selector) {
    let self = this;

    $(selector).unbind('click');
    $(selector).on('click', function (e) {
      e.preventDefault();

      const selection = window.getSelection();
      if (selection.toString().length !== 0) {
        return false;
      }

      if ($(this).attr('disabled') !== undefined) return false;

      self.ajaxLink($(this).attr('href'), $(this).attr('target'), false, $(this).attr('loader'), $(this).attr('after-submit'), this, $(this).data());
    });
  }

  bindJsonClick (selector) {
    let self = this;

    $(selector).unbind('click');
    $(selector).on('click', function (e) {
      e.preventDefault();

      const selection = window.getSelection();
      if (selection.toString().length !== 0) {
        return false;
      }

      if ($(this).attr('disabled') !== undefined) {
        return false;
      }

      self.jsonLink($(this).attr('href'), $(this).attr('target'), false, $(this).attr('loader'), $(this).attr('after-submit'), this);
    });
  }

  bindLinkClick (selector) {
    const self = this;

    $(selector)
      .unbind('click')
      .on('click', function (e) {
        e.preventDefault();

        const selection = window.getSelection();
        if (selection.toString().length !== 0) {
          return false;
        }

        if ($(this).attr('disabled') !== undefined) {
          return false;
        }

        if ($(this).attr('loader') === 'true') {
          $(this).addClass(self.settings.loader.class);
        }

        self.redirect($(this).attr('href'));
      });
  }

  bindAjaxForm (selector) {
    let self = this;

    $(selector).each(function () {
      var formObj = $(this);

      if (formObj.find('input[name=close]').length === 0) {
        formObj.append("<input type='hidden' name='close' value='0'>");
      }

      formObj.find('[type=submit]').each(function () {
        $(this).unbind('click');
        $(this).on('click', function () {
          switch ($(this).attr('role')) {
            case 'save' : formObj.find('input[name=close]').val(0); break;
            case 'save&exit' : formObj.find('input[name=close]').val(1); break;
          }
        });
      });

      formObj.ajaxForm({
        beforeSubmit: function (arr, form, ops) {
          if (self.blocked || formObj.attr('disabled') !== undefined || formObj.find('[type=submit]').attr('disabled') !== undefined) {
            return false;
          }

          self.blocked = true;

          if (formObj.attr('loader')) {
            formObj.find('[type=submit]').addClass(self.settings.loader.class);
          }

          if (formObj.attr('before-submit')) {
            return (web._runFuncByName(formObj.attr('before-submit'), window));
          } else {
            formObj.addClass('sending').blur();
          }
        },
        success: function (data, statusText, xhr, form) {
          formObj.removeClass('sending');

          if (formObj.attr('after-submit')) {
            self.blocked = false;
            self._runFuncByName(formObj.attr('after-submit'), window, data);
          }

          $('#' + formObj.attr('target')).html(data);
          self.bindAll($('#' + formObj.attr('target')));

          self.blocked = false;
          formObj.find('[type=submit]').delay(0).queue(function () {
            $(this).removeClass(self.settings.loader.class).dequeue();
          });
        },
        error: function (xhr, ajaxOptions, thrownError) {
          self.blocked = false;
          formObj.removeClass('sending');
          formObj.find('[type=submit]').delay(0).queue(function () {
            $(this).removeClass(self.settings.loader.class).dequeue();
          });
        }
      });
    });
  }

  parseFeedback (jQform, data) {
    let showFeedback = () => {
      if (jQform.data('msg-type') === 'alert') {
        this.modal.alert(data.msg, data.error ? this.settings.feedback.error_class : this.settings.feedback.correct_class);
      } else {
        if (jQform.find('.' + this.settings.feedback.class).length === 0) {
          jQform.append("<div class='" + this.settings.feedback['class'] + "'></div>");
        }

        jQform.find('.' + this.settings.feedback['class'])
          .html(data.msg)
          .removeClass(data.error ? this.settings.feedback.correct_class : this.settings.feedback.error_class)
          .addClass(data.error ? this.settings.feedback.error_class : this.settings.feedback.correct_class)
          .fadeIn();
      }
    };

    if (!jQform.data('feedback') || jQform.data('feedback') === 'all') {
      showFeedback();
    } else if (jQform.data('feedback') === 'error') {
      if (data.error) {
        showFeedback();
      } else {
        jQform.find('.' + this.settings.feedback.class).remove();
      }
    } else if (jQform.data('feedback') === 'success') {
      if (!data.error) {
        showFeedback();
      } else {
        jQform.find('.' + this.settings.feedback['class']).remove();
      }
    }
  }

  bindJsonForm (selector) {
    let self = this;

    $(selector).each(function () {
      let jQform = $(this);

      if (jQform.find('input[name=close]').length === 0) { jQform.append("<input type='hidden' name='close' value='0'>"); }

      jQform.find('[type=submit]').each(function () {
        $(this).unbind('click');
        $(this).on('click', function () {
          switch ($(this).attr('role')) {
            case 'save' : jQform.find('input[name=close]').val(0); break;
            case 'save&exit' : jQform.find('input[name=close]').val(1); break;
          }
        });
      });

      let submitButton = jQform.find('[type=submit]');

      jQform.ajaxForm({
        url: jQform.attr('action'),
        type: jQform.attr('method'),
        dataType: 'json',
        beforeSubmit: function (arr, form, ops) {
          if (self.blocked || jQform.attr('disabled') !== undefined || jQform.find('[type=submit]').attr('disabled') !== undefined) {
            return false;
          }

          self.blocked = true;

          if (jQform.attr('loader')) {
            submitButton.addClass(self.settings.loader.class);
          }

          jQform.find('.' + self.settings.forms.error_class).removeClass(self.settings.forms.error_class);
          jQform.find('.' + self.settings.feedback['class']).fadeOut('fast');

          if (jQform.attr('before-submit')) {
            return (self._runFuncByName(jQform.attr('before-submit'), window));
          } else {
            jQform.addClass(self.settings.forms.sending_class).blur();
          }
        },
        success: function (data, textStatus) {
          if (data.error) {
            if (jQform.attr('after-error')) {
              self.blocked = false;
              self._runFuncByName(jQform.attr('after-error'), window, data);
            }

            if (jQform.data('validator')) {
              jQform.find("[name='" + data.field + "']").closest(self.settings.forms.group).addClass('has-error');

              if (data.field) {
                jQform.find("[name='" + data.field + "']").closest('input, select').focus();

                if (jQform.data('tooltip')) {
                  self.showToolTip(jQform, data);
                } else {
                  self.parseFeedback(jQform, data);
                }
              } else {
                self.parseFeedback(jQform, data);
              }
            } else {
              self.parseFeedback(jQform, data);
            }
          } else {
            self.parseFeedback(jQform, data);

            if (jQform.attr('after-submit')) {
              self.blocked = false;
              self._runFuncByName(jQform.attr('after-submit'), window, data);
            }

            if (parseInt(data.close) === 1 && self.modal) {
              self.modal.close();
            }
          }

          submitButton.removeClass(self.settings.loader.class);

          self.blocked = false;
        },
        error: function (xhr, ajaxOptions, thrownError, form) {
          submitButton.remove();
          self.blocked = false;
        }
      });
    });
  }

  showToolTip (jQform, res) {
    if (this.popover) {
      const element = jQform.find(`[name="${res.field}"]`);
      const placement = res.data && res.data.placement;

      this.popover.tooltip(element, res.msg, placement);
    }
  }

  bindJsonFormSubmit (selector) {
    let self = this;

    $(selector).unbind('submit');
    $(selector).on('submit', function (e) {
      e.preventDefault();
      self.formJSONSubmit(selector);
    });
  }

  bindUploadForm (selector) {
    const self = this;
    $(selector).each(function () {
      let form = this;
      let input = $(form).find(':file');
      let uploadButton = $(form).find('[type=button]');

      $(form).on('submit', function () {
        if (self.blocked) return false;

        self.blocked = true;

        var formData = new FormData($(form)[0]);
        var preview = $(form).data('preview') || null;
        var target = $(form).data('target') || null;

        if ($(form).find('.' + self.settings.feedback.class).length === 0) { $(form).append("<div class='" + self.settings.feedbackclass + "'></div>"); }

        $(form).find('.' + self.settings.loader.class).fadeIn('fast').show();
        $(form).find('.' + self.settings.forms.error_class).removeClass(self.settings.forms.error_class);
        $(form).find('.' + self.settings.feedback.class).fadeOut('fast');

        if (uploadButton) {
          uploadButton.addClass(self.settings.loader.class);
        }

        $.ajax({
          url: $(form).attr('action'),
          type: 'post',
          data: formData,
          dataType: 'json',
          cache: false,
          contentType: false,
          processData: false,
          xhr: () => {
            var myXhr = $.ajaxSettings.xhr();
            if (myXhr.upload) { myXhr.upload.addEventListener('progress', this.uploadProgress, false); }
            return myXhr;
          },
          success: function (data) {
            if (!data.error) {
              if (data.msg !== false) { $(form).find('.' + self.settings.feedback.class).html(data.msg).removeClass(self.settings.feedback.error_class).addClass(self.settings.feedback.correct_class).fadeIn(); }

              if (preview) {
                $(preview).css({'background-image': 'url(' + data.data.path + ')'});
              }

              if (target) {
                $(target).attr('value', data.data.filename);
              }

              if ($(form).attr('after-submit')) {
                self.blocked = false;
                self._runFuncByName($(form).attr('after-submit'), window, data);
              }
            } else {
              $(form).find('.' + self.settings.feedback.class).html(data.msg).removeClass(self.settings.feedback.correct_class).addClass(self.settings.feedback.error_class).fadeIn();
              input.val('');
            }

            if (uploadButton) {
              $(form).find(self.settings.loader.selector).removeClass(self.settings.loader.class);
            }

            self.blocked = false;
          },
          error: function (xhr, ajaxOptions, thrownError, form) {
            if (uploadButton) {
              $(form).find(self.settings.loader.selector).removeClass(self.settings.loader.class);
            }
            self.blocked = false;
          }
        });
        return false;
      });

      $(`[form-id="${$(form).attr('id')}"]`).on('click', function () {
        if (self.blocked) return false;

        $(input).trigger('click');
      });

      $(input).on('change', function () {
        if (self.blocked) return false;

        $(form).submit();
      });
    });
  }

  uploadProgress (p) {
    // console.log(p);
  }

  confirm (msg) {
    return (confirm(msg));
  }

  loginRequired (settings) {
    if (!settings) {
      settings = {transition: 'bounce', forcedClose: true};
    }

    if (this.modal) {
      this.modal.open(this.settings.login_required.template);
    }
  }

  bindLoginRequired (selector) {
    if (this.modal) {
      this.modal.bindOpen(selector, this.settings.login_required.template);
    }
  }

  bindPaginator (selector, pageContainer) {
    let self = this;
    let curpag = parseInt($(selector).find('.active').attr('pag'));
    let lastpag = parseInt($(selector).find('[name=lastpage]').val());

    $(selector).on('click', '.link', function (e) {
      e.preventDefault();

      const selection = window.getSelection();
      if (selection.toString().length !== 0) {
        return false;
      }

      if (!$(this).hasClass('prev') && !$(this).hasClass('next')) {
        self.ajaxReplace($(this).attr('href'), $(this).closest(pageContainer).attr('id'), 'ipage=' + $(this).attr('pag'), false, $(this).attr('after-submit'), this, $(this).data());
      } else {
        if ($(this).attr('disabled') !== 'disabled') {
          self.ajaxReplace($(this).attr('href'), $(this).closest(pageContainer).attr('id'), 'ipage=' + parseInt(curpag + parseInt($(this).attr('pag'))), false, $(this).attr('after-submit'), this, $(this).data());
        }
      }
    });

    $(selector).on('click', '.form', function (e) {
      e.preventDefault();

      const selection = window.getSelection();
      if (selection.toString().length !== 0) {
        return false;
      }

      if (!$(this).hasClass('prev') && !$(this).hasClass('next')) {
        self.ajaxForm($(this).attr('href'), $(`#${$(this).attr('href')}`).attr('target'), '&ipage=' + $(this).attr('pag'), false, {type: 'replace'});
      } else {
        if ($(this).attr('disabled') !== 'disabled') {
          self.ajaxForm($(this).attr('href'), $(`#${$(this).attr('href')}`).attr('target'), '&ipage=' + parseInt(curpag + parseInt($(this).attr('pag'), false, {type: 'replace'})));
        }
      }
    });

    if (curpag === 1) {
      $(selector).find('.prev').attr('disabled', 'disabled').unbind('click');
    }

    if (curpag === lastpag) {
      let next = $(selector).find('.next').attr('disabled', 'disabled');
      next.unbind('click');
    }
  }

  bindMenu (menu, option, dropdownOption) {
    let loader;
    let self = this;

    $(menu).find(option).unbind('click');
    $(menu).each(function () {
      let parentMenu = this;

      $(parentMenu).find(option).each(function () {
        $(this).unbind('click');
        $(this).on('click', function (e) {
          if (self.blocked) return false;

          e.preventDefault();

          const selection = window.getSelection();
          if (selection.toString().length !== 0) {
            return false;
          }

          $(parentMenu).find(option).removeClass('active');
          $(parentMenu).find(dropdownOption).removeClass('active');

          $(this).addClass('active');

          var parentDropdownItem = $(this).parents(dropdownOption);
          if (parentDropdownItem) {
            parentDropdownItem.addClass('active');
          }

          loader = $(this).attr('loader') ? $(this).attr('loader') : $(parentMenu).attr('loader');

          if ($(this).attr('href')) {
            let target = $(this).attr('target') || $(parentMenu).attr('target');

            self.ajaxLink($(this).attr('href'), target, false, loader, $(this).attr('after-submit'), this, $(parentMenu).data());
          } else if ($(this).attr('after-submit')) {
            self.blocked = false;
            self._runFuncByName($(this).attr('after-submit'), window);
          }
        });
      });
    });
  }

  bindOpenTab (item) {
    var self = this;
    var tabIdPool = [];

    $(item).unbind('click');
    $(item).on('click', function () {
      const selection = window.getSelection();
      if (selection.toString().length !== 0) {
        return false;
      }

      var targetMenu = $(this).attr('target') || false;

      if (targetMenu) {
        var newTab = null;
        var newContent = null;
        var curTab = $(targetMenu).find('.active').first();
        var curContent = $("[tab-ref='" + $(curTab).attr('tab-id') + "']");
        var tabId = $(this).attr('tab-id');

        if (!tabId) {
          tabId = Math.floor(Math.random() * (9999 - 1000) + 1000);

          while (tabIdPool.indexOf(tabId) !== -1) {
            tabId = Math.floor(Math.random() * (9999 - 1000) + 1000);
          }

          tabIdPool.push(tabId);
          $(this).attr('tab-id', tabId);
        } else {
          if (tabIdPool.indexOf(tabId) === -1) { tabIdPool.push(tabId); }
        }

        if ($(targetMenu).find("[tab-id='" + tabId + "']").length === 0) {
          // Creamos la nueva pestaña
          newTab = $(curTab.first().clone());

          newTab.attr({'tab-id': tabId, 'data-href': $(this).data('href')});
          newTab.addClass('active');
          newTab.html($(this).data('tagname'));
          newTab.append("<div role='close-tab'></div>");

          if ($(this).data('close-class')) {
            newTab.find("[role='close-tab']").addClass($(this).data('close-class'));
            newTab.find("[role='close-tab']").on('click', function () {
              var prevTab = newTab.prev(self.settings.menu_tab.item);
              newTab.remove();
              $("[tab-ref='" + newTab.attr('tab-id') + "']").remove();
              prevTab.trigger('click');
            });
          }

          $(targetMenu).append(newTab);

          self.bindMenuTab(targetMenu, self.settings.menu_tab.item);
        } else {
          // La nueva pestaña ya existía
          newTab = $($(targetMenu).find("[tab-id='" + tabId + "']"));
        }

        curTab.removeClass('active');
        newTab.addClass('active');

        if ($("[tab-ref='" + newTab.attr('tab-id') + "']").length === 0) {
          newContent = curContent.clone();
          newContent.attr({'id': $(targetMenu).attr('target') + '-' + tabId, 'tab-ref': tabId});
          curContent.parent().append(newContent);

          if (newTab.data('href')) {
            self.ajaxLink($(this).data('href'), newContent.attr('id'), false, $(this).attr('loader'), false, this, $(this).data());
          }
        } else {
          newContent = $("[tab-ref='" + tabId + "']");
        }

        curContent.addClass('hide');
        newContent.removeClass('hide');
      }
    });

    $("[role='close-remote-tab']").on('click', function () {
      var targetMenu = $("[tab-id='" + $(this).data('target') + "']").parent(self.settings.menu_tab.selector);
      var prevTab = targetMenu.find('.active').prev(self.settings.menu_tab.item);
      var curTab = targetMenu.find("[tab-id='" + $(this).data('target') + "']");
      if ($(this).data('target')) {
        curTab.remove();
        $("[tab-ref='" + curTab.attr('tab-id') + "']").remove();
        $(prevTab).trigger('click');
      }
    });
  }

  bindMenuTab (menu, option) {
    let self = this;

    $(menu).find(option).unbind('click');
    $(menu).each(function () {
      let parentMenu = this;
      $(parentMenu).find(option).each(function (index) {
        if (!$(this).attr('tab-id')) { $(this).attr('tab-id', 'tab' + index); }

        var tabId = $(this).attr('tab-id');

        $(this).on('click', function (e) {
          $(parentMenu).find(option).removeClass('active');
          $(this).addClass('active');

          if ($(parentMenu).data('refresh')) {
            if ($(this).data('href')) {
              self.ajaxLink($(this).data('href'), tabId, false, $(this).attr('loader'), false, this, $(this).data());
            }
          }

          $(parentMenu).parent().find('[tab-ref]').addClass('hide');

          var menuItem = $("[tab-ref='" + tabId + "']").find('[role=menu-item].active');

          $(parentMenu).parent().find('[role=tab-nav].active').each(function (index) {
            $("[tab-ref='" + $(this).attr('tab-id') + "']").removeClass('hide');
          });

          if ($(menuItem).length > 0) {
            self.ajaxLink($(menuItem).attr('href'), $(menuItem).parent('[role=menu]').attr('target'), false, $(this).attr('loader'), false, this, $(this).data());
          }
        });
      });
    });
  }

  bindDropdownMenu (button, menu) {
    const self = this;

    $(button).each(function () {
      let obj = $(this);
      let events = false;
      let menuObj = false;

      if (obj.data('hover-open') === true) {
        events = 'click mouseenter';
      } else {
        events = 'click';
      }

      obj.unbind(events);
      obj.on(events, function (e) {
        menuObj = $(this).children(menu);
        // menuObj.parent().css({position: 'relative'});
        menuObj.css({
          display: 'auto',
          top: $(this).data('top') || '100%',
          left: $(this).data('left') || '0%'
        });

        if (menuObj.attr('visible') === 'true') {
          self.showDropdownMenu(menuObj, false);
        } else {
          self.showDropdownMenu(menuObj, true);
        }
      });

      // On mouseleave menu always hide it
      $(obj).unbind('mouseleave');
      $(obj).on('mouseleave', function (e) {
        if (menuObj) {
          self.showDropdownMenu(menuObj, false);
        }
      });
    });
  }

  showDropdownMenu (menu, show) {
    if (show === true) {
      menu.attr('visible', 'true');
      menu.removeClass('hide').addClass('show');
    } else {
      menu.attr('visible', 'false');
      menu.removeClass('show').addClass('hide');
    }
  }

  /* actionDropdown (elementList, action, icon) {
    if (action === 'show') {
      elementList.removeClass('hide').addClass('show');
    } else if (action === 'hide') {
      elementList.removeClass('show').addClass('hide');
    }
  } */

  bindMultipleCheckBox (selector, itemsCheck) {
    $(selector).unbind('click');
    $(selector).on('click', function () {
      if ($(this).prop('checked')) {
        $(itemsCheck).prop('checked', true);
      } else {
        $(itemsCheck).prop('checked', false);
      }
    });
  }

  redirect (url) {
    if (url) {
      window.location.href = url;
    }
  }

  errorHandler () {
    $(document).unbind('ajaxError');
    $(document).on('ajaxError', (e, xhr, settings, thrownError) => {
      this.blocked = false;

      if (xhr.status === 412) {
        // this.loginRequired();
        this.redirect('/');
      }

      return (false);
    });
  }

  bindConfirm (selector) {
    const self = this;

    $(selector).unbind('click');
    $(selector).on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      if (self.popover) {
        self.popover.create(this, 'confirm');
      }
    });
  }

  bindDeleteClick (selector) {
    let self = this;

    $(selector).unbind('click');
    $(selector).on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      if (self.popover) {
        self.popover.create(this, 'delete');
      }
    });
  }

  bindActivate (selector) {
    let self = this;

    $(selector).unbind('click');

    $(selector).each(function () {
      if (+$(this).attr('active') === 1 && $(this).data('active')) {
        if (!$(this).hasClass($(this).data('active'))) {
          $(this).removeClass($(this).data('inactive')).addClass($(this).data('active'));
        }
      } else if (+$(this).attr('active') === 0 && $(this).data('inactive')) {
        if (!$(this).hasClass($(this).data('inactive'))) {
          $(this).removeClass($(this).data('active')).addClass($(this).data('inactive'));
        }
      }

      let href = $(this).attr('href');
      if (href.indexOf('&active=') === -1) {
        href += `&active=${$(this).attr('active')}`;
        $(this).attr('href', href);
      }
    });

    $(selector).on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      let message = '';

      if ($(this).data('confirm') && $(this).data('confirm') === true) {
        if (+$(this).attr('active') === 1) {
          message = $(this).data('offmsg') || '¿Desactivar el registro?';
        } else if (+$(this).attr('active') === 0) {
          message = $(this).data('onmsg') || '¿Activar el registro?';
        }

        if (self.popover) {
          self.popover.create(this, 'confirm', message, false, (res) => {
            const onclass = $(this).data('active');
            const offclass = $(this).data('inactive');
            const active = +res.data.active;

            $(this).attr('active', active);

            if (active === 0 && offclass) {
              $(this).removeClass(onclass).addClass(offclass);
            } else if (active === 1 && onclass) {
              $(this).removeClass(offclass).addClass(onclass);
            }

            let href = $(this).attr('href');
            href = href.replace(/&active=([0-1])/g, '&active=' + active);

            $(this)
              .attr('href', href)
              .attr('active', active);
          });
        }
      } else {
        self.activate(this);
      }
    });
  }

  activate (obj) {
    if (this.blocked) return false;

    this.blocked = true;

    var onclass = $(obj).data('active');
    var offclass = $(obj).data('inactive');
    var arrlink = $(obj).attr('href').split('?');
    var active = $(obj).attr('active') || 0;
    var self = this;

    $.ajax({
      url: arrlink[0],
      data: arrlink[1] ? arrlink[1] + '&active=' + active : 'active=' + active,
      type: 'post',
      dataType: 'json',
      success: (res) => {
        if (!res.error) {
          // $(obj).popover('destroy');
          $(obj).attr('active', res.data.active);

          if (res.data.active === 0 && offclass) {
            $(obj).removeClass(onclass).addClass(offclass);
          } else if (res.data.active === 1 && onclass) {
            $(obj).removeClass(offclass).addClass(onclass);
          }

          $(obj).attr('active', res.data.active);

          if ($(obj).attr('after-submit')) {
            self.blocked = false;
            this._runFuncByName($(obj).attr('after-submit'), window, res.data);
          }
        }

        this.blocked = false;
      }
    });
  }

  bindToggle (selector) {
    let self = this;

    $(selector).unbind('click');
    $(selector).on('click', function (e) {
      e.preventDefault();
      const selection = window.getSelection();
      if (selection.toString().length !== 0) {
        return false;
      }

      let link = $(this).attr('href') || false;
      let target = $(this).attr('target') || false;

      if (target) {
        let that = $(this);

        if ($(this).find('.icon').length !== 0) {
          if ($(this).find('.icon').hasClass($(this).data('closed'))) {
            $(this).find('.icon').removeClass($(this).data('closed')).addClass($(this).data('opened'));
            if (link) {
              self.ajaxLink(link, target, false, false, function () {
                $('#' + target).removeClass('collapsed');

                if (that.attr('after-open')) {
                  self.blocked = false;
                  self._runFuncByName(that.attr('after-open'), window, false);
                }
              }, this, $(this).data());
            } else {
              $('#' + target).removeClass('collapsed');
              if (that.attr('after-open')) {
                self.blocked = false;
                self._runFuncByName(that.attr('after-open'), window, false);
              }
            }
          } else {
            $(this).find('.icon').removeClass($(this).data('opened')).addClass($(this).data('closed'));
            $('#' + target).addClass('collapsed');
            if (that.attr('after-close')) {
              self.blocked = false;
              self._runFuncByName(that.attr('after-close'), window, false);
            }
          }
        } else {
          if ($(this).hasClass($(this).data('closed'))) {
            $(this).removeClass($(this).data('closed')).addClass($(this).data('opened'));
            if (link) {
              self.ajaxLink(link, target, false, false, function () {
                $('#' + target).removeClass('collapsed');
                if (that.attr('after-open')) {
                  self.blocked = false;
                  self._runFuncByName(that.attr('after-open'), window, false);
                }
              }, this, $(this).data());
            } else {
              $('#' + target).removeClass('collapsed');
              if (that.attr('after-open')) {
                self.blocked = false;
                self._runFuncByName(that.attr('after-open'), window, false);
              }
            }
          } else {
            $(this).removeClass($(this).data('opened')).addClass($(this).data('closed'));
            $('#' + target).addClass('collapsed');
            if (that.attr('after-close')) {
              self.blocked = false;
              self._runFuncByName(that.attr('after-close'), window, false);
            }
          }
        }
      }
    });
  }

  bindInputGroup (selector, type) {
    let self = this;
    $(selector).each(function () {
      let group = $(this);
      let inputs = group.find('input:' + type);

      $(inputs).hide();

      $(inputs).each(function () {
        if (group.attr('default') === $(this).val()) {
          $(this).prop('checked', true);
          $(this).parent().addClass('checked');
        } else {
          $(this).prop('checked', false);
          $(this).parent().removeClass('checked');
        }
      });

      $(inputs).on('click', function () {
        if (type === 'radio') {
          $(inputs).each(function () {
            $(this).parent().removeClass('checked');
          });

          $(this).parent().addClass('checked');
        } else if (type === 'checkbox') {
          if ($(this).prop('checked') === true) {
            $(this).parent().addClass('checked');
          } else {
            $(this).parent().removeClass('checked');
          }
        }
      });

      if (group.attr('on-change')) {
        $(inputs).unbind('change');
        $(inputs).on('change', function () {
          self._runFuncByName(group.attr('on-change'), window, $(this));
        });
      }
    });
  }

  _runFuncByName (functionCall, context, extra) {
    let args;

    if (this.settings.useEval === 'true') {
      if (extra && functionCall[0] !== '$') {
        args = /\b[^()]+\((.*)\).?$/.exec(functionCall);
        if (args && args[1]) {
          functionCall = functionCall.replace(/\(.*\)/, '(' + args[1] + ', extra)');
        } else {
          functionCall = functionCall.replace(/\(.*\)/, '(extra)');
        }
      }

      return eval(functionCall);
    } else {
      args = functionCall.match(/\(([^)]+)\)/);

      if (args !== null) {
        args = args[1].split(',');
        args.forEach(function (item, i) {
          args[i] = item.trim();
        });
      } else {
        args = [];
      }

      let functionName = functionCall.split('(');
      let namespaces = functionName[0].split('.');
      let func = namespaces.pop();

      for (let i = 0; i < namespaces.length; i++) {
        context = context[namespaces[i]];
      }

      if (extra) {
        args.push(extra);
      }

      if (context[func]) {
        return context[func].apply(context, args);
      } else {
        return false;
      }
    }
  }

  bindCaptcha (selector, key) {
    let self = this;

    setTimeout(() => {
      if (this.grecaptcha) {
        $.each($(selector), function () {
          self.grecaptcha.render(this, {
            'sitekey': key
          });
        });
      }
    }, 1000);
  }

  bindAll (context) {
    context = context || document;

    this.errorHandler();
    // Links
    if (this.settings.links) {
      if (this.settings.links.link) {
        this.bindLinkClick($(context).find(this.settings.links.link));
      }

      if (this.settings.links.ajax) {
        this.bindAjaxClick($(context).find(this.settings.links.ajax));
      }

      if (this.settings.links.json) {
        this.bindJsonClick($(context).find(this.settings.links.json));
      }
    }

    // Forms
    if (this.settings.forms) {
      if (this.settings.forms.ajax) {
        this.bindAjaxForm($(context).find('form' + this.settings.forms.ajax));
      }

      if (this.settings.forms.json) {
        this.bindJsonForm($(context).find('form' + this.settings.forms.json));
      }

      if (this.settings.forms.upload) {
        this.bindUploadForm($(context).find('form' + this.settings.forms.upload));
      }
    }

    // Paginator
    if (this.settings.paginator) {
      this.bindPaginator($(context).find(this.settings.paginator.selector), this.settings.paginator.content);
    }

    // Login required
    if (this.settings.login_required) {
      this.bindLoginRequired($(context).find(this.settings.login_required.selector));
    }

    // Menu
    if (this.settings.menu) {
      this.bindMenu($(context).find(this.settings.menu.selector), this.settings.menu.item, this.settings.dropdown.selector);
    }

    // Menu-Tab
    if (this.settings.menu_tab) {
      this.bindMenuTab($(context).find(this.settings.menu_tab.selector), this.settings.menu_tab.item);
      this.bindOpenTab($(context).find(this.settings.menu_tab.tab_new));
    }

    // DatePicker
    if (this.settings.datepicker) {
      this.iniDatePicker($(context).find(this.settings.datepicker.selector));
    }

    // TimePicker
    if (this.settings.timepicker) {
      this.iniTimePicker($(context).find(this.settings.timepicker.selector));
    }

    // MonthPicker
    if (this.settings.monthpicker) {
      this.iniMonthPicker($(context).find(this.settings.monthpicker.selector));
    }

    // Input to Select
    if (this.settings.input_to_select) {
      this.inputToSelect($(context).find(this.settings.input_to_select.selector), this.settings.input_to_select.separator);
    }

    // Dropdown menu
    if (this.settings.dropdown) {
      this.bindDropdownMenu($(context).find(this.settings.dropdown.selector), this.settings.dropdown.list);
    }

    // Confirm
    if (this.settings.confirm) {
      this.bindConfirm($(context).find(this.settings.confirm.selector));
    }

    // Activate
    if (this.settings.activate) {
      this.bindActivate($(context).find(this.settings.activate.selector));
    }

    // Delete
    if (this.settings.delete) {
      this.bindDeleteClick($(context).find(this.settings.delete.selector));
    }

    // Toggle
    if (this.settings.toggle) {
      this.bindToggle($(context).find(this.settings.toggle.selector));
    }

    // Check buttons group
    if (this.settings.checkboxgroup) {
      this.bindInputGroup($(context).find(this.settings.checkboxgroup.selector), 'checkbox');
    }

    // Radio buttons group
    if (this.settings.radiogroup) {
      this.bindInputGroup($(context).find(this.settings.radiogroup.selector), 'radio');
    }

    if (this.settings.forms && this.settings.forms.google_captcha) {
      this.bindCaptcha($(context).find(this.settings.forms.google_captcha), this.settings.forms.google_captcha_key);
    }

    if (this.modal) {
      this.modal.bindAll(context);
    }

    if (this.custom) {
      this.custom.bindAll(context);
    }

    if (this.onBindAll) {
      this.onBindAll(context);
    }
  }
}



// WEBPACK FOOTER //
// ./devel/js/main.js